import apiFetch from '../../apiFetch'

export default function (paperworkId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/paperwork/${paperworkId}`, method: 'DELETE', token: token, lastAccessDate })
}
